/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-right': {
    width: 24,
    height: 24,
    viewBox: '0 96 960 960',
    data: '<path pid="0" d="M400 776V376l200 200-200 200z"/>'
  }
})
